module.exports = "/fast-coin/img/coin/anim/shine_1/shine_1_016.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_1/shine_1_016.png
// module id = 2332
// module chunks = 5